import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { map } from 'rxjs/operators';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { jobsitesWithPreload } from '../../selectors/one-click-jobsites.selector';

@Injectable()
export class OneClickJobsiteLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(jobsitesWithPreload),
      map(({ jobsites, preloadedOrder }) => {
        if (preloadedOrder) {
          formGroup.controls[OneClickBuilderField.Jobsite].setValue(preloadedOrder.jobsite.jobsiteId);
          return [
            {
              id: preloadedOrder.jobsite.jobsiteId,
              name: `${preloadedOrder.jobsite.jobsiteCode.replace(/^0+/, '')} / ${preloadedOrder.jobsite.jobsiteDesc}`,
            },
          ];
        } else {
          return jobsites.map((project) => {
            return {
              id: project.jobsite.jobsiteId,
              name: `${project.jobsite.jobsiteCode.replace(/^0+/, '')} / ${project.jobsite.jobsiteDesc}`,
            };
          });
        }
      }),
    );
  }
}
